import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import State from '../../context';

import Question from '../question';

const Quiz = ({ quiz, questions, setCurrentQuestionIndex, answers, setAnswers, done, finalLink, skipQuizText }) => {
  const state = useContext(State);


  return (
    <Wrapper>
      {questions.map(q =>
        <Question
          key={q.uuid}
          total={quiz.questions.length}
          setCurrentQuestionIndex={setCurrentQuestionIndex}
          userAnswer={answers[q.uuid]}
          correctAnswer={state.mode === 'points' ? quiz.results[0].scoring[q.uuid] : state.mode === 'single' ? answers[q.uuid] : null}
          answers={answers}
          setAnswers={setAnswers}
          question={q}
          done={done}
          finalLink={finalLink}
          skipQuizText={skipQuizText}
        />)}
    </Wrapper>
  );
};

Quiz.propTypes = {
  quiz: PropTypes.object,
  questions: PropTypes.array,
  setCurrentQuestionIndex: PropTypes.func,
  answers: PropTypes.object,
  setAnswers: PropTypes.func,
  done: PropTypes.bool,
  finalLink: PropTypes.string,
  skipQuizText: PropTypes.string
};

const Wrapper = styled.div`
  display: grid;
  gap: 2rem;
`;

export default Quiz;
